import React, { Dispatch, FC, SetStateAction, useContext, useEffect, useState } from 'react';

import { Grid } from '@material-ui/core';

import { GlobalContext } from '../../../../../store';

import FlightItem from './FlightItem/FlightItem';
import { getEnrollmentsByFlight } from '../Utils/getEnrollmentsByFlight';
import { IByFlight } from '../RoundFlights';
import PlayerCard from '../../../../../components/PlayerCard/PlayerCard';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';
import { usePlayersInTeeSheet } from '../../../../../contrib/Hooks/usePlayersInTeeSheet.hook';
import { sortBy } from '../../../../../contrib/sortBy';

interface IProps {
  searchValue: string;
  openFlights: IByFlight;
  setOpenFlights: Dispatch<SetStateAction<IByFlight>>;
}

export const IndividualFlights: FC<IProps> = props => {
  const { searchValue, openFlights, setOpenFlights } = props;

  const { adminEventEnrollments, adminEventRounds, adminEvents } = useContext(GlobalContext);

  const { eventId, roundId } = useRouteInfoState();

  const event = adminEvents[Number(eventId)];
  const round = adminEventRounds[Number(roundId)];
  const enrollments = adminEventEnrollments[Number(eventId)] || [];

  const flights = event ? event.flights.filter(flight => flight.category === 'i') : [];

  const [enrollmentsByFlight, setEnrollmentsByFlight] = useState<IByFlight>();

  const [playersInTeeSheet] = usePlayersInTeeSheet({
    enrollments,
    round
  });

  useEffect(() => {
    if (playersInTeeSheet.length) {
      const newOpenFlights = getEnrollmentsByFlight(playersInTeeSheet, searchValue);
      setOpenFlights(newOpenFlights);
    }
  }, [playersInTeeSheet]);

  useEffect(() => {
    setEnrollmentsByFlight(openFlights || getEnrollmentsByFlight(playersInTeeSheet, searchValue));
  }, [openFlights, searchValue, playersInTeeSheet]);

  const onItemToggle = (flightId: number) => (_: any, expanded: boolean) => {
    const newOpenFlights = {
      ...openFlights,
      [flightId]: {
        ...openFlights[flightId],
        expanded
      }
    };

    setOpenFlights(newOpenFlights);
  };

  return (
    <>
      {enrollmentsByFlight &&
      enrollmentsByFlight[0] &&
      enrollmentsByFlight[0].enrollments.length > 0 ? (
        <div className="unassigned-players-section">
          <h3>THESE PLAYERS NEED A FLIGHT</h3>

          <Grid container={true} spacing={2}>
            {enrollmentsByFlight[0].enrollments.map(enrollment => (
              <Grid key={enrollment.id} item={true} xs={12} sm={6} md={4}>
                <PlayerCard
                  item={enrollment}
                  key={`playerCard-${enrollment.id}`}
                  context={{ round }}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      ) : (
        <></>
      )}

      {event && round && playersInTeeSheet.length && Object.values(openFlights).length ? (
        sortBy(flights, 'asc', 'id').map(flight =>
          flight && enrollmentsByFlight ? (
            <FlightItem
              type={'player'}
              key={`panel-flight-${flight.id}`}
              item={flight}
              enrollments={
                enrollmentsByFlight[flight.id] ? enrollmentsByFlight[flight.id].enrollments : []
              }
              onToggle={onItemToggle(flight.id)}
            />
          ) : (
            <></>
          )
        )
      ) : (
        <></>
      )}
    </>
  );
};
